// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"85":"mobile","220":"serve","239":"joinUs","454":"newsList","522":"aboutUs","592":"productInfo","964":"product","970":"newsInfo"}[chunkId] + "." + {"85":"95501d51","220":"7ca592c0","239":"7f887045","454":"1922a2f1","522":"fe660b02","592":"4eecf949","964":"d70b0d1c","970":"d430305c"}[chunkId] + ".css";
};